import React, { useState, useEffect } from "react";
import { format } from "date-fns";
import styles from "./dashboard.module.css";
// import { ReactComponent as AddDevice } from "../../utils/assets/The_Num_of_Device.svg";
// import useAxiosPrivate from "../../utils/hooks/useAxiosPrivate";
import { ReactComponent as Question } from "../../utils/assets/arrow.svg";
import { ReactComponent as Arrow } from "../../utils/assets/q.svg";
import RenderCheckBox from "components/dashboard/render-checkbox";
import checkboxStyles from "../../components/dashboard/render-checkbox.module.css";
import {
    checkedCheckboxIcon,
    indeterminateCheckboxIcon,
    uncheckedCheckboxIcon,
} from "../../components/dashboard/checkbox-icons";
import { useNavigate } from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import Checkbox from "@material-ui/core/Checkbox";
import Chart from "components/UI/Chart";
import moment from "moment";
import Pagination from "@mui/material/Pagination";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
// import Jsonpack from "jsonpack/main";
import { Typography } from "@material-ui/core";
import classNames from "classnames";
import { loadColorCode, getSpo2Value } from "../../utils/change-spo2-color";
import useSSE from "../../utils/hooks/useSSE";
import { useDispatch } from "react-redux";
import { addUsers } from "../../store/actions/userAction";

const PAGE_SIZE_OPTIONS = [10, 25, 50];

export default function MainTable({
    group,
    members,
    fData,
    setFData,
    accessUser,
    count,
    loadData,
    user,
    setPageNumber,
    pageNumber,
    pageSize,
    setPageSize,
    totalPages,
    totalRecords,
}) {
    // const axios = useAxiosPrivate();
    let navigate = useNavigate();
    let dateNow = new Date();
    const dispatch = useDispatch();

    const [filedOrder, setFiledOrder] = useState("asc");
    const [keys, setKeys] = useState([]);
    const [updatedUserData, setUpdatedUserData] = useState({});

    const handlePageChange = (event, value) => {
        setPageNumber(value);
    };

    const handlePageSizeChange = (event) => {
        setPageNumber(1);
        setPageSize(Number(event.target.value));
    };

    useEffect(() => {
        loadData("asc", "first_name");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageNumber, group, pageSize]);

    useEffect(() => {
        const interval = setInterval(() => {}, 5000);

        //  getData();

        return () => clearInterval(interval);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    const changeOrder = (filed) => {
        if (filedOrder === "asc") {
            loadData("desc", filed);
            setFiledOrder("desc");
        } else {
            loadData("asc", filed);
            setFiledOrder("asc");
        }
    };
    const direct = (item) => {
        navigate("/user-details", { state: { ...item, fromCompare: false } });
    };

    const selectedCount = accessUser?.data?.length || 0;
    const allRecordsSelected =
        totalRecords > 0 && selectedCount >= totalRecords;
    const indeterminate =
        selectedCount > 0 && selectedCount < totalRecords;

    const handleToggleAll = (event) => {
        const { checked } = event.target;
        const existing = accessUser?.data || [];

        if (checked) {
            // Add all users from the current page to the global selection
            const existingIds = new Set(existing.map((u) => u.member_id));
            const merged = [
                ...existing,
                ...members.filter((m) => !existingIds.has(m.member_id)),
            ];
            dispatch(addUsers(merged));
        } else {
            // Remove only current page users from the global selection
            const pageIds = new Set(members.map((m) => m.member_id));
            const filtered = existing.filter((u) => !pageIds.has(u.member_id));
            dispatch(addUsers(filtered));
        }
    };

    // const getSPO2Value = (fData, item) => {
    //     if (Object.keys(fData).length === 0) {
    //         return "--";
    //     }
    //     if (!item?.user_id) {
    //         return "--";
    //     }
    //     if (fData[String(item?.user_id)]) {
    //         const time = fData[String(item?.user_id)][
    //             fData[String(item?.user_id)]?.length - 1
    //         ]?.spo2;
    //         if (time === undefined) {
    //             return "--";
    //         } else {
    //             return `${time}`;
    //         }

    //     } else {
    //         return "--";
    //     }
    // }

    const getLastActiveTime = (fData, item, showActiveNow = false) => {
        if (Object.keys(fData).length === 0) {
            return "--";
        }
        if (!item?.user_id) {
            return "--";
        }
        if (fData[String(item?.user_id)]) {
            const time =
                fData[String(item?.user_id)][
                    fData[String(item?.user_id)]?.length - 1
                ]?.reading_time;
            if (time === undefined) {
                return "--";
            } else {
                // Check if the device is actively receiving data (within last 60 seconds)
                if (showActiveNow) {
                    const readingTime = new Date(time);
                    const now = new Date();
                    const diffInSeconds = (now - readingTime) / 1000;

                    if (diffInSeconds <= 60) {
                        return "Active now";
                    }
                }
                // Format UTC time to local machine time using date-fns
                return format(new Date(time), "yyyy-MM-dd HH:mm:ss");
            }
        } else {
            return "--";
        }
    };

    const handleSSEData = React.useCallback(
        (parsedData) => {
            if (parsedData && parsedData.data) {
                const incoming = parsedData.data || {};

                // Always keep fData equal to the raw SSE payload
                setFData(incoming);

                // Maintain updatedUserData as "latest non-empty values"
                setUpdatedUserData((prev) => {
                    // Initial call: make updatedUserData equal to fData/incoming
                    if (!prev || Object.keys(prev).length === 0) {
                        return incoming;
                    }

                    const merged = { ...prev };

                    Object.entries(incoming).forEach(([userId, readings]) => {
                        if (Array.isArray(readings) && readings.length > 0) {
                            // Non-empty array: update latest values for this user
                            merged[userId] = readings;
                        } else if (!(userId in merged)) {
                            // Brand new user with empty array: keep it as-is
                            merged[userId] = readings;
                        }
                        // If readings is an empty array and we already have data for this user,
                        // do NOT overwrite – we keep the previous non-empty values.
                    });

                    return merged;
                });
            }
        },
        [setFData],
    );

    // Handle SSE errors
    const handleSSEError = React.useCallback((error) => {
        console.error("SSE Error:", error);
    }, []);

    // Build SSE URL so hook reconnects when members change
    const memberIds = (members || [])
        .map((m) => m?.user_id || m?.member_id || m?.id)
        .filter(Boolean)
        .join(",");
    const sseUrl = `/group/data?members=${encodeURIComponent(memberIds)}`;

    useSSE(sseUrl, handleSSEData, handleSSEError);

    // const getData = async () => {
    //   if (user.length > 0 && fromDate === "") {
    //     const { data } = await axios.post("/team/data", {
    //       only_updates: false,
    //       user_ids: user,
    //       // compress: true,
    //     });
    //     const json = Jsonpack.unpack(data.data);

    //     setFData(json);

    //     const results = Object.entries(json)
    //       .filter((item) => item[1].length)
    //       // eslint-disable-next-line
    //       .map((item) => {
    //         if (item[1][item.length - 1]?.reading_time) {
    //           return new Date(item[1][item.length - 1].reading_time);
    //         }
    //       });

    //     if (results.length) {
    //       setFromDate(new Date(Math.max(...results)).toString());
    //     }
    //   } else if (user.length > 0 && fromDate !== "") {
    //     const { data } = await axios.post("/team/data", {
    //       only_updates: true,
    //       user_ids: user,
    //       from_time: fromDate,
    //       // compress: true,
    //     });

    //     const json = Jsonpack.unpack(data.data);

    //     setFData(json);

    //     const results = Object.entries(json)
    //       // eslint-disable-next-line
    //       .map((item) => {
    //         if (item[1].length) {
    //           if (item[1][item.length - 1]?.reading_time) {
    //             return new Date(item[1][item.length - 1].reading_time);
    //           }
    //         }
    //       })
    //       .filter((record) => record);

    //     if (results.length) {
    //       setFromDate(new Date(Math.max(...results)).toString());
    //     }
    //   }
    // };

    return (
        <div>
            <div className={styles.tableHead}>
                <div className={styles.header}>
                    <div className={styles.headingCount}>
                        {/* <AddDevice className={styles.deviceIconColor} /> */}
                        <Typography
                            variant="h5"
                            style={{
                                fontSize: "0.78rem",
                                marginRight: "5px",
                                paddingLeft: "0.2rem",
                                color: "var(--primary-text-color)",
                            }}
                        >
                            <Checkbox
                                color="default"
                                className={checkboxStyles.root}
                                checked={allRecordsSelected}
                                indeterminate={indeterminate}
                                icon={uncheckedCheckboxIcon}
                                checkedIcon={checkedCheckboxIcon}
                                indeterminateIcon={indeterminateCheckboxIcon}
                                onChange={handleToggleAll}
                                style={{
                                    transform: "scale(0.8)",
                                }}
                            />
                            {accessUser?.data?.length || 0}/{totalRecords}
                        </Typography>
                    </div>
                    <div
                        className={styles.tittle1}
                        style={{ cursor: "pointer" }}
                    >
                        <Typography
                            variant="h5"
                            style={{
                                fontSize: "0.78rem",
                                marginRight: "5px",
                                color: "var(--primary-text-color)",
                            }}
                        >
                            UserName
                        </Typography>
                        <Arrow
                            style={{
                                width: "0.8rem",
                                height: "0.8rem",
                            }}
                            onClick={() => {
                                changeOrder("first_name");
                            }}
                        />
                    </div>
                    <div className={styles.tittle2}>
                        <Typography
                            variant="h5"
                            style={{
                                fontSize: "0.78rem",
                                marginRight: "5px",
                                color: "var(--primary-text-color)",
                            }}
                        >
                            SpO₂
                        </Typography>
                        <Question
                            style={{ width: "0.8rem", height: "0.8rem" }}
                        />
                    </div>
                    <div className={styles.tittle3}>
                        <Typography
                            variant="h5"
                            style={{
                                fontSize: "0.78rem",
                                marginRight: "5px",
                                color: "var(--primary-text-color)",
                            }}
                        >
                            Vitals
                        </Typography>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div
                                style={{
                                    borderBottom: "3px solid #A6CEE3",
                                    width: "1.5rem",
                                    marginRight: "5px",
                                }}
                            ></div>
                            <Typography
                                variant="h4"
                                style={{
                                    fontSize: "0.78rem",
                                    marginRight: "5px",
                                    color: "var(--primary-text-color)",
                                }}
                            >
                               SpO₂ (%)
                            </Typography>
                            <div
                                style={{
                                    borderBottom: "3px dashed #1F78B4",
                                    width: "1.5rem",
                                    margin: "0px 5px 0px 20px",
                                }}
                            ></div>
                            <Typography
                                variant="h4"
                                style={{
                                    fontSize: "0.78rem",
                                    marginRight: "5px",
                                    color: "var(--primary-text-color)",
                                }}
                            >
                                Pulse Rate (bpm)
                            </Typography>
                        </div>
                    </div>
                    <div className={styles.tittle4}>
                        <Typography
                            variant="h5"
                            style={{
                                fontSize: "0.78rem",
                                marginRight: "5px",
                                color: "var(--primary-text-color)",
                            }}
                        >
                            Last Active Time
                        </Typography>
                        <Arrow style={{ width: "0.8rem", height: "0.8rem" }} />
                    </div>
                </div>
            </div>
            <div
                style={{
                    minHeight: "content",
                    backgroundColor: "var(--primary-popup-background-color)",
                    paddingBottom: "20px",
                    borderRadius: "6px",
                }}
            >
                {members.length === 0 ? (
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "40px 0",
                            backgroundColor:
                                "var(--primary-popup-background-color)",
                        }}
                    >
                        <Typography
                            variant="h6"
                            style={{
                                fontSize: "0.9rem",

                                color: "var(--primary-text-color)",
                            }}
                        >
                            No users found for the current search.
                        </Typography>
                    </div>
                ) : (
                    members.map((item, index) => (
                        <div className={styles.container} key={item.member_id}>
                            <div
                                className={
                                    accessUser?.data?.find(
                                        (m) => m.member_id === item.member_id,
                                    )
                                        ? styles.tBodyMark
                                        : styles.tBody
                                }
                            >
                                <div
                                    className={styles.tittle6}
                                    style={{ cursor: "pointer" }}
                                >
                                    <div className={styles.item1}>
                                        <RenderCheckBox
                                            item={item}
                                            setKeys={setKeys}
                                            keys={keys}
                                        />
                                    </div>
                                    <div
                                        className={styles.item2}
                                        onClick={() => {
                                            direct(item);
                                        }}
                                    >
                                        {" "}
                                        <Avatar
                                            alt={item?.first_name}
                                            src={item.avatar_url}
                                            sx={{ width: 30, height: 30 }}
                                        />
                                    </div>
                                    <div
                                        className={styles.item3}
                                        onClick={() => {
                                            direct(item);
                                        }}
                                    >
                                        {" "}
                                        <p className={styles.tdText}>
                                            {item?.first_name}&nbsp;{" "}
                                            {item?.last_name}
                                        </p>
                                    </div>
                                </div>
                                <div className={styles.tittle7}>
                                    <p
                                        className={classNames(styles.tdNumber)}
                                        style={loadColorCode(getSpo2Value(updatedUserData, item))}
                                    >
                                        {
                                            getSpo2Value(updatedUserData, item)
                                                .value
                                        }
                                    </p>
                                </div>
                                <div className={styles.tittles}>
                                    {fData.length !== 0 && user.length > 0 ? (
                                        <Chart
                                            fData={fData[String(item?.user_id)]}
                                            height={60}
                                        />
                                    ) : (
                                        <Chart fData={[]} height={50} />
                                    )}
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                        }}
                                    >
                                        <p className={styles.chartText}>
                                            {updatedUserData[item?.user_id]
                                                ?.length > 0
                                                ? moment(
                                                      getLastActiveTime(
                                                          updatedUserData,
                                                          item,
                                                      ),
                                                  )
                                                      .subtract(2, "minutes")
                                                      .format("hh:mm:ss A")
                                                : moment(dateNow)
                                                      .subtract(2, "minutes")
                                                      .format("hh:mm:ss A")}
                                        </p>
                                        <p className={styles.chartText}>
                                            {updatedUserData[item?.user_id]
                                                ?.length > 0
                                                ? moment(
                                                      getLastActiveTime(
                                                          updatedUserData,
                                                          item,
                                                      ),
                                                  )
                                                      .subtract(1, "minutes")
                                                      .format("hh:mm:ss A")
                                                : moment(dateNow)
                                                      .subtract(1, "minutes")
                                                      .format("hh:mm:ss A")}
                                        </p>
                                        <p className={styles.chartText}>
                                            {updatedUserData[item?.user_id]
                                                ?.length > 0
                                                ? moment(
                                                      getLastActiveTime(
                                                          updatedUserData,
                                                          item,
                                                      ),
                                                  ).format("hh:mm:ss A")
                                                : moment(dateNow).format(
                                                      "hh:mm:ss A",
                                                  )}
                                        </p>
                                    </div>
                                </div>

                                <div className={styles.tittle4}>
                                    <p className={styles.lastActiveText}>
                                        {getLastActiveTime(
                                            updatedUserData,
                                            item,
                                            true,
                                        )}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))
                )}
            </div>

            <div className={styles.paginationRow}>
                <div className={styles.paginationShell}>
                    <Pagination
                        count={Math.max(1, totalPages || 0)}
                        page={Math.min(
                            pageNumber,
                            Math.max(1, totalPages || 1),
                        )}
                        onChange={handlePageChange}
                        variant="outlined"
                        shape="rounded"
                        showFirstButton={false}
                        showLastButton={false}
                        siblingCount={1}
                        boundaryCount={1}
                    />
                </div>
                <FormControl
                    size="small"
                    variant="outlined"
                    className={styles.pageSizeControl}
                >
                    <Select
                        value={pageSize}
                        onChange={handlePageSizeChange}
                        IconComponent={KeyboardArrowDownIcon}
                        MenuProps={{
                            PaperProps: {
                                className: styles.pageSizeMenuPaper,
                            },
                        }}
                        renderValue={(value) => `View ${value} items`}
                    >
                        {PAGE_SIZE_OPTIONS.map((n) => (
                            <MenuItem key={n} value={n}>
                                {n} per page
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
        </div>
    );
}
